/**************************************************
 * Nombre:       Formulario_Documentos
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import {BadgeOutlined} from "@mui/icons-material";
import {useEffect, useState} from "react";
import {TIPOSESTUDIANTES} from "../../Constantes";
import IngresoSelectFuncion from "../../Modulo_formularios/Componentes/IngresoSelectFuncion";
import {formatoMoneda} from "../../Utilidades/formatoMoneda";
import IngresoPdf from "../../Modulo_formularios/Componentes/IngresoPdf";

const Formulario_Documentos = ({...props}) => {
    const [tipo, setTipo] = useState('')

    useEffect(() => {

        let tip  =props.props.getValues('tipo')
        let valores  =props.props.getValues('valores')
        if (tip){
            let index = valores.findIndex(item => item.nombre == tip)
            setTipo(valores[index])
        }

    },[props.props.tipo])
    return (
        <form noValidate style={{width: '100%'}}>
            <Grid
                container
                justifyContent={'center'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                spacing={2}
            >


                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center'}}>
                    <Typography sx={{fontSize: 24, textAlign: 'center', lineHeight: 1.1, fontWeight: 600}}>Si le es
                        posible
                        ahora</Typography>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center'}}>
                    <Typography sx={{fontSize: 16, textAlign: 'center', lineHeight: 1.2}}>
                        Sube tu titulo de profesional o certificado que acredite tu condicion de estudiante, si no le es
                        posible en este momento nosotros proporsionaremos otro medio para que en el futuro lo haga
                    </Typography>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                    <Typography sx={{fontSize: 16, textAlign: 'center', lineHeight: 1.2}}>
                        Subir PDF
                    </Typography>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoPdf dato={'pdf'} {...props} />
                </Grid>


                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{mt: 2}}>
                    <Typography sx={{fontSize: 20, fontWeight: 600, textAlign: 'center', lineHeight: 1.2}}>
                        {`Valor a Cancelar ${formatoMoneda(tipo.valor)}`}
                    </Typography>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <Typography sx={{fontSize: 14, fontWeight: 300, textAlign: 'left', lineHeight: 1.2}}>
                        Se te enviara un correo electronico donde estan los detalles de la realizacion del pago
                    </Typography>
                </Grid>


            </Grid>

        </form>

    )

}
export default Formulario_Documentos